import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import ViewModalImage from 'modules/common/components/ViewModalImage';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { connect } from 'react-redux';
import Select, { createFilter } from 'react-select';
import { customStyle } from 'helper';
import { ModalContext } from 'App';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';
import CreateFloorAreaModal from '../modals/CreateFloorAreaModal';

const form = [{
  floor: '',
  area: '',
}];

function FloorAreaContainer({
  applicationInfo,
  applicationId,
  floorAreaList,
  getList,
  updateData,
  getActualUseList,
  actualUseList,
  type,
  isLoading,
}) {

  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);

  const handleViewImage = (value) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      title: 'View Floor Plan',
      content: <ViewModalImage value={value} />,
      modalSize: 'modal-lg',
    });
  };

  const handleAddFloorArea = (data) => () => {
    setModal({
      isOpen: true,
      content: <CreateFloorAreaModal id={applicationId} floorData={data} />,
      title: 'Add Floor Area',
      modalSize: 'modal-lg',
    });
  };

  const initMode = {
    editMode: 0,
  };

  const [mode, setMode] = useState(initMode);

  const formatFloorArea = (data) => {
    const format = data.map(item => ({
      id: _.get(item, 'id'),
      floor: _.get(item, 'attributes.floor'),
      area: _.get(item, 'attributes.area'),
      rptax_actual_use_id: _.get(item, 'attributes.rptax_actual_use_id'),
    }));
    return format;
  };

  const onSetFormData = () => {
    if (!_.isEmpty(floorAreaList)) {
      setFormData(formatFloorArea(floorAreaList));
    }
  };

  useEffect(() => {
    onSetFormData();
    getActualUseList();
  }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, [applicationId]);

  const handleMode = (command, location) => {
    onSetFormData();
    switch (location) {
      case 'EDIT':
        setMode({ ...mode, editMode: command });
        break;
      default:
        break;
    }
  };

  const handleCancel = () => {
    handleMode(0, 'EDIT');
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = { floor_storey_areas: formData };
    updateData(applicationId, args, () => {
      setModal({ isOpen: false });
      getList(applicationId);
      handleMode(0, 'EDIT');
    });
  };

  const handleRemoveFloorArea = detail => (e) => {
    e.preventDefault();


    ConfirmAlert(
      'Are you sure you want to remove this floor area?',
      () => {
        const newItem = formData.slice(0, -1);
        setFormData(newItem);
        const data = floorAreaList.filter(x => (+x.attributes.floor !== +detail.floor));
        setFormData(formatFloorArea(data));
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
    );
  };

  const handleOnChangeRow = (key, index) => (e) => {
    setFormData(formData.map((item) => {
      if (+item.id === +index) {
        return {
          ...item,
          [key]: e.target.value,
        };
      }
      return item;
    }));
  };

  const actualUseOptions = actualUseList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleLandClassSelect = (key, index) => (e) => {
    setFormData(formData.map((item) => {
      if (+item.id === +index) {
        return {
          ...item,
          [key]: e.value,
        };
      }
      return item;
    }));
  };

  return (
    <>
      <div className="p-3 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row mb-3 d-flex align-items-center">
              <div className="col py-0">
                <h3 className="m-0 text-color font-weight-bold">Floor Area</h3>
              </div>
              {type !== 'history' && (
                <div className="row py-0 m-0 d-flex mr-3">
                  {
                    mode.editMode === 0 ? (
                      <>
                        {(floorAreaList.length === 0) && (
                          <button
                            type="button"
                            onClick={handleAddFloorArea(floorAreaList)}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 mr-2 ml-auto"
                          >
                            <i className="fas fa-plus" /> Add Floor Area
                          </button>
                        )}
                        {(floorAreaList.length > 0) &&
                          [
                            'PENDING',
                            'FOR APPRAISAL AND ASSESSMENT',
                            'TRANSFERRED',
                            'FOR REASSESSMENT',
                          ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 && type !== 'history'
                          && (
                            <button
                              type="button"
                              onClick={() => (handleMode(1, 'EDIT'))}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                            >
                              <i className="far fa-edit p-0 mr-1" /> Edit
                            </button>
                          )}
                      </>
                    ) : (
                      <React.Fragment>
                        <button
                          type="submit"
                          onClick={handleOnSubmit}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 mr-2 ml-auto"
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          onClick={handleCancel}
                          className="btn btn-secondary btn-round font-weight-bold px-4"
                        >
                          Cancel
                        </button>
                      </React.Fragment>
                    )
                  }
                </div>
              )}
            </div>
            {(floorAreaList && floorAreaList.length <= 0) && (
              <div className="d-flex align-items-center justify-content-center h-100">
                <div className="text-center mx-auto py-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                  />
                  <p className="emp-title mb-0"> No Item Found </p>
                </div>
              </div>
            )}
            {(floorAreaList.length > 0 && type !== 'history') && (
              <div className="row my-3 mx-0">
                <table className="css-table table table-sm table-striped table-hover">
                  <thead className="table-header">
                    <tr>
                      <td width="200"><b>Floor Number</b></td>
                      <td width="200"><b>Area</b></td>
                      <td width="250"><b>Actual Use</b></td>
                      {type !== 'history' && mode.editMode === 1 && (
                        <td><b>Action</b></td>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {mode.editMode === 0
                      ? (
                        floorAreaList.map((item) => (
                          <tr key={item.id}>
                            <td width="200" className="history-color">{_.get(item, 'attributes.floor')}</td>
                            <td width="200" className="history-color">{_.get(item, 'attributes.area') || 0}</td>
                            <td width="250" className="history-color">{_.get(item, 'attributes.actual_use') || ''}</td>
                          </tr>
                        ))
                      ) : (
                        formData.map((el, i) => (
                          <tr key={el.id}>
                            <td width="50" className="header-color">{_.get(el, 'floor')}</td>
                            <td width="200">
                              <input
                                className="form-control"
                                type="number"
                                id="area"
                                name="area"
                                autoComplete="none"
                                onChange={handleOnChangeRow('area', el.id)}
                                value={_.get(el, 'area') || ''}
                              />
                            </td>
                            <td width="250">
                              <Select
                                options={actualUseOptions}
                                styles={customStyle}
                                filterOption={createFilter({
                                  ignoreAccents: false,
                                })}
                                placeholder="Select Actual Use"
                                value={actualUseOptions.filter(x => +_.get(el, 'rptax_actual_use_id') === +_.get(x, 'value')) || ''}
                                onChange={handleLandClassSelect('rptax_actual_use_id', el.id)}
                              />
                            </td>
                            {type !== 'history' && (
                              <td>
                                {(floorAreaList.length === i + 1)
                                  && (
                                    <button type="button" className="btn-blank" onClick={handleRemoveFloorArea(el)}>
                                      <i className="far fa-trash-alt icon-delete" />
                                    </button>
                                  )}
                              </td>
                            )}
                          </tr>
                        ))
                      )}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
        <hr />
        <div className="title font-weight-bold">
          Building Plan
        </div>
        <div className="row mb-3 d-flex align-items-center">
          <div className="col-6" />
          <div className="col-6">
            <button
              className="btn-blank"
              type="button"
              onClick={handleViewImage(_.get(applicationInfo, 'attributes.floor_plan_photo_url'))}
            >
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(_.get(applicationInfo, 'attributes.floor_plan_photo_url') || '')
                    ? (_.get(applicationInfo, 'attributes.floor_plan_photo_url') || ImagePlaceholder)
                    : (_.get(applicationInfo, 'attributes.floor_plan_photo_url.cdnUrl') || ImagePlaceholder)
                }
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

FloorAreaContainer.propTypes = {
  applicationId: PropTypes.string,
  getList: PropTypes.instanceOf(Function).isRequired,
  floorAreaList: PropTypes.instanceOf(Array).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  applicationInfo: PropTypes.instanceOf(Object),
};

FloorAreaContainer.defaultProps = {
  applicationId: '',
  type: '',
  applicationInfo: {}
};

const mapStateToProps = ({ api }) => ({
  floorAreaList: _.get(api, `${c.GET_LIST}.list`) || [],
  actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LIST) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(FloorAreaContainer);
